import { TColumItem } from '../components/types';

/**
 * Will return the name of the make
 *
 * @param {*} field field where to populated
 * @return {*}  {string}
 */
export const getMakeField = (item: TColumItem): string => {
    if ('make' in item) return `${item.make?.name || ''}`;

    return '- - -';
};
